import { render, staticRenderFns } from "./BindGameacc.vue?vue&type=template&id=443d5a05&scoped=true&"
import script from "./BindGameacc.vue?vue&type=script&lang=js&"
export * from "./BindGameacc.vue?vue&type=script&lang=js&"
import style0 from "./BindGameacc.vue?vue&type=style&index=0&id=443d5a05&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443d5a05",
  null
  
)

export default component.exports